module.exports = __webpack_public_path__ + "img/leapton.1917ab8b.png";